export default () => ({
	Header: 'View Name',
	accessor: 'name'
});
